import React from 'react';
import { categoryImagesByVendor, getProviderConfig, randomCategoryImagesByVendor } from '../../config';
import { useSelectedCategory } from '../../stores/appStore';
import styles from './CategoryPreview.scss';
import { GalleryGrid } from '@wix/gg-components';

export function CategoryPreview() {
  const category = useSelectedCategory();
  const { vendor } = getProviderConfig();

  const images = category ? categoryImagesByVendor[vendor][category] : randomCategoryImagesByVendor[vendor];

  return (
    <div className={styles.wrapper}>
      <GalleryGrid className={styles.galleryWrapper} images={images?.slice(0, 3) ?? []} imagesFit="cover" />
    </div>
  );
}
